"use client"
import { HttpTypes } from "@medusajs/types"
import BlurImage from "@modules/common/components/blur-image"

type Props = { images: HttpTypes.StoreProductImage[] }

export default function ImageGalleryDopesnow({ images }: Props) {
  if (!images?.length) return null
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-[2px]">
      {images.map((img, i) => (
        <div key={img.id || i} className="relative aspect-[3/4] bg-[#F5F5F5] overflow-hidden">
          <BlurImage
            src={img.url}
            alt={`Product image ${i + 1}`}
            fill
            className="object-cover hover:scale-105 transition-transform duration-300"
            priority={i < 2}
          />
        </div>
      ))}
    </div>
  )
}
